<div class="container-fluid">
    <div class="row">

      <div class="card shadow-sm p-0">
        <div class="card-header">
          <h3 class="card-title">{{ categoryId ? 'Update Category' : 'Edit Category' }} </h3>
        </div>
        <div class="card-body">
          <category-form
            [category]="category"
          />
        </div>
      </div>
    </div>
    
  </div>
  